export default "__VITE_ASSET__yvPvdJDV__"